(function ($) {
  if (
    !window ||
    !window.ys ||
    !window.ys.ws_search_url ||
    !window.ys.blog_id ||
    !window.ys.site_path
  ) {
    return;
  }
  var API_URL = window.ys.ws_search_url,
    RECONNECT_TIMEOUT = 1000;

  var seriesPostTypeName = window.ys.series.postTypeName || '';
  var seriesLabel = window.ys.series.singularLabel || '';
  var seriesAddLabel = window.ys.series.addLabel || false;

  var Client = (function () {
    function Client(url, init) {
      this.lastIdx = 0;
      this.absoluteUrl = new URL(url, window.location.href);
      if (this.absoluteUrl.protocol === 'https:') {
        this.absoluteUrl.protocol = 'wss:';
      } else {
        this.absoluteUrl.protocol = 'ws:';
      }
      if (init.timeout) {
        this.timeout = init.timeout;
      } else {
        this.timeout = 1000;
      }
      this.absoluteUrl.searchParams.append('blogId', '' + init.blogId);
      for (var postType in init.postTypes) {
        this.absoluteUrl.searchParams.append('postType', postType);
      }
      if (typeof init.taxonomies !== 'undefined') {
        this.absoluteUrl.searchParams.append(
          'taxonomy',
          JSON.stringify(init.taxonomies)
        );
      }
      if (typeof init.maxPosts !== 'undefined') {
        this.absoluteUrl.searchParams.append('maxPosts', '' + init.maxPosts);
      }
      this.connect();
    }
    Client.prototype.connect = function () {
      var _this = this;
      var ws = new WebSocket(this.absoluteUrl.toString());
      ws.onclose = function (e) {
        setTimeout(function () {
          _this.connect();
        }, _this.timeout);
      };
      ws.onerror = function (err) {
        _this.ws.close();
      };
      this.ws = ws;
    };
    Client.prototype.search = function (query) {
      var _this = this;
      return new Promise(function (resolve, reject) {
        if (_this.ws.readyState !== _this.ws.OPEN) {
          reject('ws not open');
          return;
        }
        var idx = ++_this.lastIdx;
        var onMessage = function (ev) {
          var msg = JSON.parse(ev.data);
          if (msg.i < idx) {
            return; // waiting for another message
          } else if (msg.i === idx) {
            if (msg.data === null) {
              reject('es err');
            } else {
              resolve(msg.data);
            }
          } else {
            reject('obsolete');
          }
          _this.ws.removeEventListener('message', onMessage);
        };
        _this.ws.addEventListener('message', onMessage);
        _this.ws.send(
          JSON.stringify({
            i: idx,
            query: query,
          })
        );
      });
    };
    return Client;
  })();
  if ('WebSocket' in window) {
    var suggestionsEl = document.querySelector('#suggestions'),
      inputEl = document.querySelector('#js-suggestions-input'),
      articlesEl = document.querySelector('#js-suggestions-articles'),
      tagsEl = document.querySelector('#js-suggestions-tags'),
      categoriesEl = document.querySelector('#js-suggestions-categories'),
      articlesContentEl = document.querySelector('#js-suggestions-articles dd'),
      tagsContentEl = document.querySelector('#js-suggestions-tags dd'),
      categoriesContentEl = document.querySelector(
        '#js-suggestions-categories dd'
      );
    var WS = null;

    var renderHtml = function (data) {
      var articlesItems = data.posts.map(function (post) {
        var title = post.postTitle;
        if (seriesAddLabel && post.postType === seriesPostTypeName) {
          title += ' - ' + seriesLabel;
        }
        return '<a href="' + post.permalink + '">' + title + '</a>';
      });
      var tagsItems = data.taxonomies.post_tag.map(function (term) {
        return (
          '<a href="/' +
          window.ys.site_path +
          '/tag/' +
          term.slug +
          '">' +
          term.title +
          '</a>'
        );
      });
      var categoriesItems = data.taxonomies.category.map(function (term) {
        return (
          '<a href="/' +
          window.ys.site_path +
          '/category/' +
          term.slug +
          '">' +
          term.title +
          '</a>'
        );
      });

      var hasResults = false;
      // Show/hide used/unused elements
      if (articlesItems.length > 0) {
        articlesContentEl.innerHTML = articlesItems.join('');
        articlesEl.classList.remove('u-hidden');
        articlesEl.classList.remove(
          'sa-menu__search__suggestions__category--hidden'
        );
        hasResults = true;
      } else {
        articlesEl.classList.add('u-hidden');
        articlesEl.classList.add(
          'sa-menu__search__suggestions__category--hidden'
        );
      }
      if (tagsItems.length > 0) {
        tagsContentEl.innerHTML = tagsItems.join('');
        tagsEl.classList.remove('u-hidden');
        tagsEl.classList.remove(
          'sa-menu__search__suggestions__category--hidden'
        );
        hasResults = true;
      } else {
        tagsEl.classList.add('u-hidden');
        tagsEl.classList.add('sa-menu__search__suggestions__category--hidden');
      }
      if (categoriesItems.length > 0) {
        categoriesContentEl.innerHTML = categoriesItems.join('');
        categoriesEl.classList.remove('u-hidden');
        categoriesEl.classList.remove(
          'sa-menu__search__suggestions__category--hidden'
        );
        hasResults = true;
      } else {
        categoriesEl.classList.add('u-hidden');
        categoriesEl.classList.add(
          'sa-menu__search__suggestions__category--hidden'
        );
      }

      suggestionsEl.classList.toggle(
        'sa-menu__search__suggestions--has-results',
        hasResults
      );
    };
    var connectWS = function () {
      if (!WS) {
        WS = new Client(API_URL, {
          blogId: window.ys.blog_id,
          timeout: RECONNECT_TIMEOUT,
          postTypes: { post: true, series: true },
          taxonomies: {
            post_tag: {
              count: 3,
              sort: [
                { field: 'count', order: 'desc' },
                { field: '_score', order: 'desc' },
              ],
            },
            category: {
              count: 3,
              sort: [
                { field: 'count', order: 'desc' },
                { field: '_score', order: 'desc' },
              ],
            },
          },
          maxPosts: 5,
        });
      }

      if (inputEl && inputEl.value.trim() !== '') {
        WS.search(inputEl.value)
          .then(renderHtml)
          .catch(function (e) {});
      }
    };
    var hideSuggestions = function () {
      articlesEl.classList.add('u-hidden');
      tagsEl.classList.add('u-hidden');
      categoriesEl.classList.add('u-hidden');
    };
    var inputChangeHandler = function (event) {
      if (inputEl.value) {
        WS.search(inputEl.value)
          .then(renderHtml)
          .catch(function (e) {});
      } else {
        // Empty query -> hide suggestions
        hideSuggestions();
      }
    };

    $('body').click(function (e) {
      if (!$(suggestionsEl).has(e.target).length) {
        hideSuggestions();
      }
    });

    inputEl.addEventListener('focus', connectWS);
    inputEl.addEventListener('input', inputChangeHandler);
  }
})(jQuery);
